import React, { Component, useState } from "react";
import axios from "axios";
import Modal from "react-modal";
import Dashboard from "./Dashboard";
import MangeDashboard from "./MangeDashboard";
import { useNavigate } from "react-router-dom";
import Toast from "./Tost";
import "./Ehraz.css";
import SelfiExample from "./SelfiExample";
import { useMediaQuery } from "beautiful-react-hooks";
import { toast } from "react-toastify";
import Resizer from "react-image-file-resizer";
import { formatDate } from "@mobiscroll/react";

function Ehraz() {
  var IsDigit = new RegExp(/^[0-9]/);
  var IsSheba = new RegExp(/^IR[0-9]/);

  const BASEURL = "https://api.sinatether.com/Auth/Ehraz/";
  const navigate = useNavigate();

  const [message, setmessage] = useState("");
  const [type, settype] = useState("");

  const [meli, setmeli] = useState("");
  const [profile, setprofile] = useState("");
  const [cart, setcart] = useState("");
  const [codeMeli, setcodeMeli] = useState("");
  const [cartNumbrr, setcartNumbrr] = useState("");
  const [shebaNumber, setshebaNumber] = useState("");
  const [meliUrl, setmeliUrl] = useState("");
  const [profileUrl, setprofileUrl] = useState("");
  const [cartUrl, setcartUrl] = useState("");
  const [name, setname] = useState("");
  const [token, settoken] = useState("");
  const [error, seterror] = useState({
    codeMeli: "",
    cartNumbrr: "",
    shebaNumber: "",
    flag: true,
  });
  const [flag, setflag] = useState(true);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const isSmall = useMediaQuery("(max-width: 768px)");
  const [isLoading, setIsLoading] = useState(false);

  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1200,
        1200,
        "JPEG",
        100,
        0,
        (uri) => {
          resolve(uri);
        },
        "file"
      );
    });

  async function handleChange(event) {
    if (
      (event.target.name == "profile" ||
        event.target.name == "meli" ||
        event.target.name == "cart") &&
      event.target.files[0]
    ) {
      let file = event.target.files[0];
      if (file.size > 10240000) {
        toast.dismiss();
        toast.error("حداکثر سایز فایل انتخابی  ده مگابایت است ");
        return;
      }
    }

    if (event.target.name == "meli" && event.target.files[0]) {
      setmeliUrl(URL.createObjectURL(event.target.files[0]));
      const imageMeli = await resizeFile(event.target.files[0]);

      setmeli(imageMeli);
    } else if (event.target.name == "profile" && event.target.files[0]) {
      setprofileUrl(URL.createObjectURL(event.target.files[0]));
      const image = await resizeFile(event.target.files[0]);

      setprofile(image);
    } else if (event.target.name == "cart" && event.target.files[0]) {
      setcartUrl(URL.createObjectURL(event.target.files[0]));
      const imageCart = await resizeFile(event.target.files[0]);

      setcart(imageCart);
    } else if (event.target.name == "codeMeli") {
      let targetvalue = event.target.value;
      if (IsDigit.test(targetvalue)) {
        if (targetvalue.length == 10) {
          seterror({ ...error, codeMeli: "" });
          setcodeMeli(targetvalue);
          setflag(false);
        } else {
          seterror({
            ...error,
            codeMeli: "کد ملی خود را به درستی وارد نمایید",
          });
          setflag(true);
        }
      } else {
        seterror({ ...error, codeMeli: "کد ملی خود را به درستی وارد نمایید" });
        setflag(true);
      }
    } else if (event.target.name == "cartNumber") {
      let targetvalue = event.target.value;
      if (IsDigit.test(targetvalue)) {
        if (targetvalue.length == 16) {
          seterror({ ...error, cartNumbrr: "" });
          setcartNumbrr(targetvalue);
          setflag(false);
        } else {
          seterror({
            ...error,
            cartNumbrr: "شماره کارت خود را به درستی وارد نمایید",
          });
          setflag(true);
        }
      } else {
        seterror({
          ...error,
          cartNumbrr: "شماره کارت خود را به درستی وارد نمایید",
        });
        setflag(true);
      }
    } else if (event.target.name == "shebaNumber") {
      let targetvalue = event.target.value;
      targetvalue = `IR${targetvalue}`;
      console.log(targetvalue);

      if (IsSheba.test(targetvalue) && targetvalue.length == 26) {
        seterror({ ...error, shebaNumber: "" });
        setshebaNumber(targetvalue);
        setflag(false);
      } else {
        seterror({
          ...error,
          shebaNumber: "شماره شبا خود را به درستی وارد نمایید",
        });
        setflag(false);
      }
    }
  }

  function handelexample() {
    setIsOpen(true);
  }

  async function handelSubmit(event) {
    event.preventDefault();
    if (
      !name ||
      !meli ||
      !profile ||
      !cart ||
      !codeMeli ||
      !cartNumbrr ||
      !shebaNumber
    ) {
      toast.dismiss();
      toast.error("لطفا اطلاعات خود را کامل وارد نمایید");
      return;
    }

    console.log(`cart lentgh is ${cart}`);
    console.log(`cart lentgh is ${name}`);

    const id = toast.loading("درحال بارگذاری اطلاعات شما...");
    setIsLoading(true);
    const formdata = new FormData();
    if (sessionStorage.getItem("user")) {
      var phone = sessionStorage.getItem("user");
      settoken(localStorage.getItem("TOKEN"));
    }

    formdata.append("name", name);
    formdata.append("phone", phone);
    formdata.append("meli", meli);
    formdata.append("profile", profile);
    formdata.append("cart", cart);
    formdata.append("codeMeli", codeMeli);
    formdata.append("cartNumbrr", cartNumbrr);
    formdata.append("shebaNumber", shebaNumber);

    console.log(formatDate);

    await axios
      .post("https://api.sinatether.com/Auth/Ehraz/", formdata, {
        withCredentials: true,
      })
      .then((response) => {
        console.log(response);
        if (response.status == 200) {
          toast.update(id, {
            render: "اطلاعات به درستی ارسال شد",
            type: "success",
            isLoading: false,
          });

          setIsLoading(false);

          navigate("/Ehrazwaiting");
        }
      })
      .catch((error) => {
        if (error) {
          toast.dismiss();

          toast.error("اطلاعات به درستی ارسال نشد دوباره امتحان کنید");
          setIsLoading(false);
        }
      });
  }

  return (
    <MangeDashboard state={3}>
      <Toast type={type} message={message} />
      <SelfiExample modalIsOpen={modalIsOpen} Openchanger={setIsOpen} />

      <div className="jfsjhsdbsehraz  align-item-center">
        <div className="container align-items-center setStyleEhraz ">
          <div className={"col-md-12 align-items-center pb5678"}>
            <form>
              <div className="identity-content pcss34242">
                <img src="./images/shield.svg" alt="" />
                <h6 className={"text-large pt-2"}>
                  تصاویر مدارک مشابه تصاویر نمونه ارسال شود
                </h6>
              </div>
              <div className="row pt-2">
                <div className={"col-md-6"}>
                  <div className={"form-group"}>
                    <input
                      type="text"
                      name={"codeMeli"}
                      className="form-control input-ehraz"
                      placeholder={"کد ملی"}
                      onChange={handleChange}
                    />
                    <div className={"text-medium text-danger"}>
                      {error.codeMeli}
                    </div>
                  </div>

                  <div className={"form-group"}>
                    <input
                      type="text"
                      name={"name"}
                      className="form-control input-ehraz"
                      placeholder={"نام و نام خانوادگی "}
                      value={name}
                      onChange={(e) => {
                        setname(e.target.value);
                      }}
                      required={"وارد نمایید"}
                    />
                  </div>

                  <div className="form-group">
                    <div
                      className="file-upload-wrapper"
                      data-text="عکس کارت ملی"
                    >
                      <input
                        type={"file"}
                        name={"meli"}
                        className={"form-control"}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <span className="float-right text-medium text-warning pl-2 muted24245335">
                      {" "}
                      حداکثر اندازه10مگابایت است
                    </span>
                    <div className={"text-left"}>
                      {meliUrl ? (
                        <img
                          data-display-toggle={meliUrl}
                          src={meliUrl}
                          className="imgfield rounded mt-2 ml-2"
                          alt={""}
                          onError={"this.style.display='none'"}
                        />
                      ) : (
                        <img src={""} />
                      )}
                    </div>
                  </div>

                  <div className="form-group">
                    <img
                      src={"images/selfiexample.png"}
                      className="w-25 h-25  rounded mt-2 ml-2 mb-2"
                      alt={"عکس خود"}
                    />
                    <button
                      type={"button"}
                      className={"btn bttexx btnsm ml-2"}
                      onClick={handelexample}
                    >
                      متن تعهدنامه
                    </button>

                    <div
                      className="file-upload-wrapper"
                      data-text="آپلود عکس سلفی"
                    >
                      <input
                        type={"file"}
                        name={"profile"}
                        className={"form-control"}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <h6 className="float-right mt-1 text-medium text-warning pl-2 muted24245335">
                      {" "}
                      حداکثر اندازه 10مگابایت است
                    </h6>

                    {isSmall ? (
                      <div className={"text-left"}>
                        {profileUrl ? (
                          <img
                            data-display-toggle={profileUrl}
                            src={profileUrl}
                            className="imgfield  rounded mt-2 ml-2"
                            alt={""}
                            onError={"this.style.display='none'"}
                          />
                        ) : (
                          <img src={""} />
                        )}
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>

                <div className={"col-md-6"}>
                  <div className={"form-group"}>
                    <input
                      type="text"
                      name={"cartNumber"}
                      className="form-control input-ehraz"
                      placeholder={"شماره کارت"}
                      onChange={handleChange}
                      required
                    />

                    <div className={"text-medium text-danger"}>
                      {error.cartNumbrr}
                    </div>
                  </div>

                  <div className={"form-group"}>
                    <div className={"row"}>
                      <div className={"col-10 pl-2 pr-0"}>
                        <input
                          type="text"
                          name={"shebaNumber"}
                          className="form-control pr-0 pl-2 input-ehraz fdkkfdmfgkd"
                          placeholder={"شماره شبا بدون IR"}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className={"col-2 tex-center pl-0 "}>
                        <input
                          type={"text"}
                          className="form-control KSJDHSG545335 input-ehraz"
                          value={"IR"}
                          readOnly={true}
                        />
                      </div>
                    </div>
                    <div className={"text-medium text-danger "}>
                      {error.shebaNumber}
                    </div>
                  </div>

                  <div className="form-group">
                    <div
                      className="file-upload-wrapper"
                      data-text="عکس کارت بانکی"
                    >
                      <input
                        name={"cart"}
                        type="file"
                        className="form-control"
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <h6 className="float-right mt-1 text-medium text-warning pl-2 muted24245335">
                      {" "}
                      حداکثر اندازه 10مگابایت است
                    </h6>
                    <div className={"text-left"}>
                      {cartUrl ? (
                        <img
                          data-display-toggle={cartUrl}
                          src={cartUrl}
                          className="imgfield rounded mt-2 ml-2"
                          alt={""}
                          onError={"this.style.display='none'"}
                        />
                      ) : (
                        <img src={""} />
                      )}
                    </div>
                  </div>

                  {isSmall ? (
                    <></>
                  ) : (
                    <div className={"form-group"}>
                      <div className={"text-right"}>
                        {profileUrl ? (
                          <img
                            data-display-toggle={profileUrl}
                            src={profileUrl}
                            className="imgfield  rounded mt-2 ml-2"
                            alt={""}
                            onError={"this.style.display='none'"}
                          />
                        ) : (
                          <img src={""} />
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="align-items-center text-center pb-2">
                <button
                  disabled={flag}
                  type="submit"
                  className="btn btn-sehraz pl-5 pr-5"
                  onClick={handelSubmit}
                >
                  {isLoading ? (
                    <i className="fa fa-spinner fa-spin"></i>
                  ) : (
                    <span>ارسال</span>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </MangeDashboard>
  );
}
export default Ehraz;
